import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import KeyValueDTO from '../models/generic/KeyValueDTO';

export class CheckpointApiController {
    // get: Checkpoint/GetAllCheckpoints
    public RouteGetAllCheckpoints = () => `Checkpoint/GetAllCheckpoints`;
    public getAllCheckpoints(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<string, number>[]>> {
        let url = this.RouteGetAllCheckpoints();
        return HttpApi.RestRequest<any, KeyValueDTO<string, number>[]>(null, 'get', url, requestOptions);
    }
}
var service = new CheckpointApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/CheckpointApiController.ts